import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["locationGroupSelect", "locationSelect"];

  static values = {
    locationsByLocationGroup: String,
  };

  connect() {
    // Initialize location filtering
    if (this.hasLocationsByLocationGroupValue) {
      this.locationsByLocationGroup = JSON.parse(this.locationsByLocationGroupValue);
    }
  }

  updateLocations(event) {
    const locationGroupId = event.target.value;

    const currentlySelected = Array.from(this.locationSelectTarget.selectedOptions).map(
      (option) => option.value
    );
    if (locationGroupId) {
      // Show locations for the selected group
      const options = (this.locationsByLocationGroup[locationGroupId] || [])
        .map((location) => ({
          label: location.name,
          value: location.id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
      this.setDropdownOptions(this.locationSelectTarget, options);
    } else {
      // Show all locations when no group is selected
      const options = Object.values(this.locationsByLocationGroup)
        .flat()
        .map((location) => ({
          label: location.name,
          value: location.id,
          selected: currentlySelected.includes(location.id.toString()),
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
      this.setDropdownOptions(this.locationSelectTarget, options);
    }
  }

  disableElement(element) {
    element.disabled = true;
  }

  enableElement(element) {
    element.disabled = false;
  }

  setDropdownOptions(select, options) {
    select.replaceChildren(
      ...options.map(({ label, value, selected }) => {
        const option = new Option(label, value);
        if (selected) option.selected = true;
        return option;
      })
    );
  }
}
